import { Asset } from "contentful"
import { TypeExpertBioSkeleton, TypeTimeTapReasonsSkeleton } from "#/types/contentful"
import { RawContentfulConditionSkeleton } from "#/lib/contentful/utils/conditionUtils"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"

export type TimeTapReason = {
  reasonId: number
}

export type File = {
  url: string
}

export type Headshot = {
  file: File
  id: string
}

export type ExpertBio = {
  id: string
  slug: string
  name: string
  credentials: string
  headshot: Headshot
  description: string
  conditions: EntryWithoutUnresolvableLinks<RawContentfulConditionSkeleton>[]
  professionalId: number
  timeTapReasons: TimeTapReason[]
}

const mapContentToHeadshot = ({ fields, sys }: Asset<"WITHOUT_UNRESOLVABLE_LINKS">): Headshot => {
  if (!fields || !sys) {
    return null
  }
  const { file } = fields
  const { id } = sys
  return {
    file,
    id
  }
}

const mapContentToTimeTapReason = ({
  fields
}: EntryWithoutUnresolvableLinks<TypeTimeTapReasonsSkeleton>): TimeTapReason => {
  if (!fields) {
    return null
  }
  const { reasonId } = fields
  return {
    reasonId
  }
}

export const mapContentToExpertBio = ({
  fields,
  sys
}: EntryWithoutUnresolvableLinks<TypeExpertBioSkeleton>): ExpertBio => {
  if (!fields || !sys) {
    return null
  }
  const { slug, name, credentials, headshot, description, conditions, professionalId, reasonIds } = fields
  const { id } = sys

  return {
    id,
    slug,
    name,
    credentials,
    headshot: headshot && mapContentToHeadshot(headshot),
    description,
    conditions,
    professionalId,
    timeTapReasons: reasonIds && reasonIds.map(mapContentToTimeTapReason)
  }
}
